<template>
    <div>
        <div class="columns is-multiline">
            <div class="column is-full">
                <a :href="exportProducts" class="button is-primary is-rounded" target="_blank">
                    Exportar productos
                    <b-icon icon="download" size="is-small" class="m-l-5"></b-icon>
                </a>

                <b-button
                rounded
                class="m-l-5"
                @click="importModalActive=true"
                type="is-primary">
                    Importar archivo .csv
                    <b-icon icon="upload" size="is-small" class="m-l-5"></b-icon>
                </b-button> 

            </div>
            <div class="column is-two-quarters">
                <b-field label="Buscar">
                    <b-input
                    v-model="searchQ"
                    type="search"
                    icon="search"
                    placeholder="Buscar nombre o codigo"
                    @input="updateSearchParams">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-quarter">
                <b-field label="Categoria">
                    <b-select v-model="categoryQ"
                    @input="updateSearchParams"
                    expanded>
                        <option value="">------</option>
                        <option v-for="cat in categories" :key="cat.id" :value="cat">
                            {{cat.title}}
                        </option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-one-quarter">
                <b-field label="Subcategoria">
                    <b-select v-model="subcategoryQ"
                    @input="updateSearchParams"
                    expanded>
                        <option value="">------</option>
                        <option v-for="sub in subcategoriesForSearch" :key="sub.id" :value="sub">
                            {{sub.title}}
                        </option>
                    </b-select>
                </b-field>
            </div>
        </div>

        <b-table 
            :data="count > 0 ? products : []"
            :loading="isLoading"
            :hoverable="true"
            >

            <template slot-scope="props">
                <b-table-column width="40" numeric>
                    <a class="has-text-danger"
                    @click="prodToDelete=props.row; deleteModal=true">
                        <b-icon icon="trash" size="is-small">
                        </b-icon>
                    </a>
                </b-table-column>

                <b-table-column field="title" label="Titulo">
                    <a :href="productDetailEndpoint.replace('0000', props.row.id)">{{ props.row.title }}</a>
                </b-table-column>
                <b-table-column field="code" label="Codigo">
                    <span v-if="props.row.code">{{props.row.code}}</span> <span v-else>-</span>
                </b-table-column>
                <b-table-column field="status" label="Estado">
                    <span class="tag" :class="statusTag(props.row.status)">{{ props.row.getStatusDisplay }}</span>
                    <span class="tag is-success m-l-5" v-if="props.row.classified">Clasificado</span>
                </b-table-column>

                <b-table-column field="currencySymbol" label="Moneda">
                    {{ props.row.currencySymbol }}
                </b-table-column>

                <b-table-column field="price" label="Precio">
                    {{ props.row.price }}
                </b-table-column>

                <b-table-column field="timestamp" label="Creado" centered>
                    <span class="tag is-success">
                        {{ new Date(props.row.timestamp).toLocaleDateString() }}
                    </span>
                </b-table-column>

                <b-table-column field="image" label="Imagen?">
                    <div class="has-text-centered">
                        <b-icon v-if="props.row.getImage" icon="check-circle" class="has-text-success"></b-icon>
                        <b-icon v-else icon="times-circle" class="has-text-light"></b-icon>
                    </div>
                </b-table-column>
                
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="frown"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>

        
        <div class="p-top-30">
            <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="onPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>
        <div class="columns is-centered m-t-30">
            <div class="column is-full has-text-centered">
                <a :href="createProduct"
                class="button is-primary is-rounded">
                <b-icon icon="plus" size="is-small" style="margin-right:5px;">
                </b-icon> Crear nuevo producto
                </a>
            </div>
        </div>

         <b-modal :active.sync="deleteModal" scroll="keep">
            <div class="modal-card" style="width: auto">

                <div class="modal-card-body has-text-centered">
                    <p>
                        Esta accion es irreversible. 
                    </p>
                    <p>Vas a eliminar el producto <b>{{prodToDelete.title}}</b></p>
                    <p> <b>Seguro que quieres continuar?</b> </p>
                    <div class="columns m-t-20">
                        <div class="column has-text-centered is-full">
                            <b-button
                                type="is-grey"
                                rounded
                                @click="deleteModal=false">
                                    Cancelar
                            </b-button>
                            <b-button
                                type="is-danger"
                                rounded
                                @click="deleteProd">
                                    Eliminar
                            </b-button>
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </b-modal>

        <b-modal :active.sync="importModalActive" scroll="keep">
            <div class="modal-card" style="width: auto">

                <div class="modal-card-body has-text-centered">
                    
                    <form :action="importUrl" method="POST" enctype="multipart/form-data">
                        <div v-html="csrfToken"></div>
                        
                        <b-field label="Archivo" message="Solo acepta archivos .csv">
                            <input type="file" id="file1" name="file">
                        </b-field>
                        <hr> 
                        <p class="has-text-weight-bold m-t-10">Requisitos del archivo:</p>
                        <div class="has-text-left">
                            <p>Como regla general, evitar usar tildes en los nombres de las columnas. Las mayusculas no afectan asi que se pueden usar sin problema.</p>
                            <p>- *El codigo es mandatorio. Con el validamos si el producto existe o no, el archivo debe tener una columna llamada <strong>codigo o code</strong></p>
                            <p>- *El titulo debe estar en la columna llamada <strong>titulo o title</strong>. Se usa para crear el producto que no existe, no para editar.</p>
                            <p>- *El precio debe estar en la columna <strong>precio o price</strong></p>
                            <p>- *La moneda tiene que estar en la columna <strong>moneda o currency</strong>, y las opciones validas de este campo son <strong>USD o UYU</strong>. Si la opcion es invalida, se usa como default <strong>UYU</strong></p>
                            <p>- (Opcional) La descripcion sera encontrada en la columna llamada <strong>descripcion o description</strong></p>
                        </div>
                        <hr> 
                        <button class="m-t-5 button is-primary is-rounded" type="submit">
                            Enviar archivo
                            <b-icon icon="paper-plane" size="is-small" class="m-l-5"></b-icon>
                        </button>
                    </form>
                    
                </div>
                
            </div>
        </b-modal>

    </div>
</template>

<script>
import {getHandler, deleteHandler, debounce} from "./../../../../services/http.js"

export default {
    name:"ProductTable",
    props: {
        productListEndpoint: {
            type:String,
            default:""
        },
        productDetailEndpoint:{
            type:String,
            defult:""
        },
        createProduct:{
            type:String,
            default:''
        },
        productDelete:{
            type:String,
            default:''
        },
        categories:{
            type:Array,
            default: new Array([])
        },
        subcategories:{
            type:Array,
            default: new Array([])
        },
        exportProducts:{
            type:String,
            default:""
        },
        csrfToken:{
            type:String,
            default:""
        },
        importUrl:{
            type:String,
            default:""
        }
    },
    data() {
        return{
            products:[],
            isLoading: false,
            count:0,
            perPage:24,
            page:1,
            deleteModal:false,
            prodToDelete:{},
            searchQ:"",
            categoryQ:"",
            subcategoryQ:"",
            importModalActive:false
        }
    },

    methods:{
        async fetchProducts(){
            this.isLoading = true
            let url = `${this.productListEndpoint}?page=${this.page}&search=${this.searchQ}`
            if (this.categoryQ){
                url = url + `&cat_slug=${this.categoryQ.slug}`
            }
            if (this.subcategoryQ){
                url = url + `&sub_slug=${this.subcategoryQ.slug}`
            }
            let response = await getHandler(url, {success:false, error:false,})
            this.count = response.count
            this.products = response.results
            this.isLoading = false
        },
        onPageChange(page){
            this.page = page
            this.fetchProducts()
        },
        async deleteProd(){
            let msgS={
                resource:"toast",
                text:"Producto eliminado con exito."
            }
            let msgE={
                resource:"toast",
                text:"No se pudo eliminar el producto."
            }
            
            let url = this.productDelete.replace("0000", this.prodToDelete.id)
            let resp = await deleteHandler(url, {error:msgE, success:msgS})
            this.fetchProducts()
            this.deleteModal = false
        },
        statusTag(status){
            if (status == "O"){
                return 'is-info'
            }
                
            else if( status == "P"){
                return 'is-success'
            }
            return 'is-black'
        },

        updateSearchParams: debounce(function(){
            this.page = 1
            this.fetchProducts()
        }, 500),

    },
    computed:{
        subcategoriesForSearch(){
            var subs = this.subcategories.filter((element)=>{
                return element.category == this.categoryQ.id
            })
            return subs
        }
    },
    created(){
        this.page = 1
        this.fetchProducts()
    },

}
</script>
